import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMylocation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25M11.25 7V3.785a8.25 8.25 0 0 0-7.465 7.47H7a.75.75 0 0 1 0 1.5H3.786a8.25 8.25 0 0 0 7.474 7.46V17a.75.75 0 0 1 1.5 0v3.213a8.25 8.25 0 0 0 7.454-7.458H17a.75.75 0 0 1 0-1.5h3.215a8.25 8.25 0 0 0-7.465-7.47V7a.75.75 0 0 1-1.5 0"
  }));
}
var IcMylocation = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMylocation));

export { IcMylocation as I };
